import { RestApiColumns } from "components/Columns";
import EndpointSecurityTable from "components/EndpointSecurityTable";
import React from "react";
import { Link } from "react-router";
import { Container, Header, Icon } from "semantic-ui-react";

function EndpointSecurity() {
  const api = {
    name: "exampleAPI",
    hasPrivateWAF: true,
    hasGlobalWAF: false,
    curityScopes: [
      {
        api_endpoint: "http://api.example.com",
        authType: "oAuth2",
        isIPWhitelisted: true,
        scope: "scope",
      },
    ],
  };

  return (
    <Container fluid>
      <Header as="h2" textAlign="center">
        Endpoint Security
      </Header>
      <Header dividing>Introduction</Header>
      The <Link to="/endpoint-security">Endpoint Security</Link> page will have
      the comprehensive information about the security details of all the REST
      endpoints and WebSocket routes such as curity scopes, whether the endpoint
      has whitelisted IPs, has private or global WAF and the authorization type.
      The APIs are categorized based on the modules to which the APIs belong.
      The list of modules can be seen in the left sidebar under the API type.
      <br />
      <br />
      The user can filter the APIs by using the <i>Filter APIs</i> dropdown. The
      APIs can be filtered by the domain(Public or Private) and whether the
      endpoints are IP whitelisted. The filters can be cleared by clicking on
      the <Icon name="cancel" /> icon.
      <Header dividing>Example</Header>
      The below example API has private WAF and not global WAF. The endpoint
      http://api.example.com has whitelisted IPs.
      <EndpointSecurityTable columns={RestApiColumns} api={api} />
    </Container>
  );
}

export default EndpointSecurity;
